module.exports = __webpack_public_path__ + "img/monitor.7d9057c2.png";